import { apiProxyRequest } from "Api/apiProxyRequest";

type DeleteSshKeyRequestProps = { userId: string; keyId: string };

export const deleteSshKeyRequest = ({
  userId,
  keyId
}: DeleteSshKeyRequestProps) =>
  apiProxyRequest<undefined>(
    `/users/${encodeURIComponent(userId)}/ssh-keys/${encodeURIComponent(keyId)}`,
    "DELETE"
  );
